<template>
  <!-- 购买后更换属性 (구매 후 옵션 변경) — 1688 구매·결제가 끝난 주문에서 옵션이 바뀐 건을 반영한다(YZY 2026-10-08).
       미리보기(쓰기 없음) → 변경 내용 표 확인 → 적용. 계산은 서버 inventory-services/option-change.js -->
  <b-modal :visible="value" @change="v => $emit('input', v)" size="xl" hide-footer
           title="🔁 购买后更换属性 (구매 후 옵션 변경)" body-class="pt-2" @shown="init">
    <div class="small text-muted mb-2">
      适用于已在1688付款的订单，客户要求且卖家同意更换属性时 (1688 결제까지 끝난 주문에서 고객 요구 + 판매자 동의로 옵션이 바뀐 경우).<br>
      新属性的采购申请已存在则数量合并，否则直接更换属性 (새 옵션 요청건이 이미 있으면 수량 합산, 없으면 옵션 교체). 原申请不会被取消 (옛 건은 취소되지 않고 「옵션변경 이전」 표시).
    </div>
    <div class="mb-2"><b>1688订单号 (주문번호)</b> {{ orderNo }}</div>
    <div v-if="error" class="alert alert-danger py-1 small" style="white-space: pre-line">{{ error }}</div>

    <table class="table table-sm table-bordered mb-2">
      <thead class="thead-light">
        <tr><th>原属性 (옛 옵션)</th><th>新属性 (새 옵션)</th><th style="width:110px">数量 (수량·비우면 전부)</th><th style="width:200px">条码 (바코드·교체일 때)</th><th style="width:50px"></th></tr>
      </thead>
      <tbody>
        <tr v-for="(c, i) in changes" :key="i">
          <td><b-form-select v-model="c.from" :options="optionList" size="sm" @change="reset"></b-form-select></td>
          <td>
            <b-form-input v-model.trim="c.to" size="sm" list="ppo-options" placeholder="新属性 (예: 米白板扣款)" @input="reset"></b-form-input>
          </td>
          <td><b-form-input v-model="c.qty" type="number" size="sm" min="1" @input="reset"></b-form-input></td>
          <td>
            <b-form-select v-model="c.barcodeMode" size="sm" :options="barcodeModes" @change="c.barcode = ''; reset()"></b-form-select>
            <b-form-input v-if="c.barcodeMode === 'new'" v-model.trim="c.barcode" size="sm" class="mt-1" list="ppo-barcodes" placeholder="新条码 (새 바코드)" @input="reset"></b-form-input>
          </td>
          <td><b-button size="sm" variant="outline-danger" @click="changes.splice(i, 1); reset()">×</b-button></td>
        </tr>
      </tbody>
    </table>
    <datalist id="ppo-barcodes"><option v-for="b in barcodeList" :key="b" :value="b"></option></datalist>
    <datalist id="ppo-options"><option v-for="o in optionList" :key="o.value" :value="o.value"></option></datalist>
    <div class="mb-3">
      <b-button size="sm" variant="outline-secondary" class="mr-2" @click="changes.push({ from: null, to: '', qty: '', barcodeMode: 'keep', barcode: '' }); reset()">+ 添加 (추가)</b-button>
      <b-button size="sm" variant="primary" :disabled="loading || !canPreview" @click="preview">
        <b-spinner v-if="loading && !result" small class="mr-1"></b-spinner>预览 (미리보기)
      </b-button>
    </div>

    <template v-if="result">
      <div v-for="(b, i) in result.blocks" :key="'b' + i" class="alert alert-danger py-1 small mb-1">
        ⛔ {{ b.中 }} ({{ b.한 }})
      </div>
      <div v-for="(w, i) in result.warnings" :key="'w' + i" class="alert alert-warning py-1 small mb-1">
        ⚠ {{ w.中 }} ({{ w.한 }})
      </div>
      <div v-if="result.rows.length" class="mt-2">
        <div class="mb-1">
          <b>变更预览 (변경 미리보기)</b> — {{ result.rows.length }}件 (건) · 合并 (합산) {{ result.summary.합산 }} · 转出 (이전) {{ result.summary.이전 }} · 更换 (교체) {{ result.summary.교체 }}
          <span v-if="!result.summary.금액재배분" class="text-danger ml-2">金额未重新分配 (금액 재배분 안 함)</span>
        </div>
        <div style="overflow-x:auto">
          <table class="table table-sm table-bordered">
            <thead class="thead-light">
              <tr>
                <th>条码 (바코드)</th><th>属性 (옵션)</th><th>处理 (처리)</th>
                <th>采购数量 (구매요청수량)</th><th>1688订单数量 (주문수량)</th>
                <th>实付 (협상후 실결제)</th><th>单价 (단가)</th><th>数量 (협상후 수량)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="r in result.rows" :key="r.docId">
                <td class="small">{{ r.바코드 }}<span v-if="r.변경후바코드 !== r.바코드"> → <b>{{ r.변경후바코드 }}</b></span></td>
                <td>{{ r.옵션 }}<span v-if="r.변경후옵션 !== r.옵션"> → <b>{{ r.변경후옵션 }}</b></span></td>
                <td>{{ roleText(r.role) }}</td>
                <td>{{ r.수량.전 }} → <b>{{ r.수량.후 }}</b></td>
                <td>{{ r.주문수량.전 == null ? '-' : r.주문수량.전 }} → <b>{{ r.주문수량.후 == null ? '-' : r.주문수량.후 }}</b></td>
                <td>{{ r.금액.전.협상후_실결제금액 }} → <b>{{ r.금액.후.협상후_실결제금액 }}</b></td>
                <td>{{ r.금액.전.협상후_상품금액 }} → <b>{{ r.금액.후.협상후_상품금액 }}</b></td>
                <td>{{ r.금액.전.협상후_수량 }} → <b>{{ r.금액.후.협상후_수량 }}</b></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="text-right">
          <b-button variant="success" :disabled="!result.ok || !result.confirm || applying" @click="apply">
            <b-spinner v-if="applying" small class="mr-1"></b-spinner>确认并应用 (확인 후 적용)
          </b-button>
        </div>
      </div>
    </template>

    <div v-if="done" class="alert alert-success mt-2">
      ✅ 已应用 {{ done.영향건수 }}件 (적용 완료). 记录号 (기록 번호) {{ done.changeId }} — 可在下方恢复 (아래에서 되돌릴 수 있습니다).
    </div>

    <hr>
    <div class="d-flex align-items-center mb-1">
      <b>更换记录 (변경 기록)</b>
      <b-button size="sm" variant="link" @click="loadLogs">刷新 (새로고침)</b-button>
    </div>
    <table v-if="logs.length" class="table table-sm table-bordered small">
      <thead class="thead-light"><tr><th>时间 (시각)</th><th>人员 (담당)</th><th>内容 (내용)</th><th>状态 (상태)</th><th></th></tr></thead>
      <tbody>
        <tr v-for="l in logs" :key="l.changeId">
          <td>{{ new Date(l.at).toLocaleString() }}</td>
          <td>{{ l.byName }}</td>
          <td>{{ (l.changes || []).map(c => c.from + ' → ' + c.to + (c.qty ? ' ×' + c.qty : '') + (c.barcode ? ' [条码 ' + c.barcode + ']' : '')).join(', ') }}</td>
          <td>{{ l.status }}</td>
          <td><b-button v-if="l.status === 'applied'" size="sm" variant="outline-danger" @click="revert(l)">恢复 (되돌리기)</b-button></td>
        </tr>
      </tbody>
    </table>
    <div v-else class="small text-muted">无记录 (기록 없음)</div>
  </b-modal>
</template>

<script>
import axios from 'axios'

export default {
  name: 'PostPurchaseOptionModal',
  props: {
    value: { type: Boolean, default: false },
    // 선택한 요청건 — 같은 1688 주문번호의 옵션 목록은 siblings(같은 주문의 요청건들)에서 만든다
    item: { type: Object, default: null },
    siblings: { type: Array, default: () => [] }
  },
  data() {
    return { changes: [{ from: null, to: '', qty: '', barcodeMode: 'keep', barcode: '' }], result: null, loading: false, applying: false, error: '', done: null, logs: [] }
  },
  computed: {
    orderNo() { return this.item && this.item.주문정보 ? String(this.item.주문정보['1688주문번호'] || '') : '' },
    optionList() {
      const seen = {}
      return this.siblings.filter(d => d.주문정보 && String(d.주문정보['1688주문번호'] || '') === this.orderNo).map(d => {
        const v = [d.옵션1_중국어, d.옵션2_중국어].map(s => String(s || '').replace(/\s+/g, '')).filter(Boolean).join('|')
        return { value: v, text: v + ' (' + d.구매요청수량 + ')' }
      }).filter(o => o.value && !seen[o.value] && (seen[o.value] = true))
    },
    barcodeModes() { return [{ value: 'keep', text: '保持不变 (그대로)' }, { value: 'new', text: '新条码 (새로 입력/선택)' }] },
    barcodeList() { return [...new Set(this.siblings.map(d => d.바코드).filter(Boolean))] },
    canPreview() { return this.orderNo && this.changes.length && this.changes.every(c => c.from && c.to && (c.barcodeMode !== 'new' || c.barcode)) }
  },
  methods: {
    init() {
      this.changes = [{ from: this.item ? [this.item.옵션1_중국어, this.item.옵션2_중국어].map(s => String(s || '').replace(/\s+/g, '')).filter(Boolean).join('|') : null, to: '', qty: '', barcodeMode: 'keep', barcode: '' }]
      this.result = null; this.error = ''; this.done = null
      this.loadLogs()
    },
    reset() { this.result = null; this.done = null },
    roleText(role) {
      return (role || []).map(r => ({ 합산: '合并 (합산)', 이전: '转出 (이전됨)', 교체: '更换 (교체)', 금액재배분: '金额重分配 (금액 재배분)' }[r] || r)).join(' + ')
    },
    body() { return { orderNo: this.orderNo, changes: this.changes.map(c => ({ from: c.from, to: c.to, qty: c.qty === '' ? undefined : Number(c.qty), barcode: c.barcodeMode === 'new' && c.barcode ? c.barcode : undefined })) } },
    async preview() {
      this.loading = true; this.error = ''; this.done = null
      try {
        const r = await axios.post('/api/reqpurchase/optionChange/preview', this.body())
        if (r.data.요청결과 !== '성공') throw new Error(r.data.error && r.data.error.errorMessage || '预览失败 (미리보기 실패)')
        this.result = r.data
      } catch (e) { console.error('optionChange preview', e); this.error = e.message; this.result = null } finally { this.loading = false }
    },
    async apply() {
      if (!this.result || !this.result.confirm) return
      if (!window.confirm('确认应用？\n' + this.result.rows.length + '件 (건)\n적용하시겠습니까?')) return
      this.applying = true; this.error = ''
      try {
        const r = await axios.post('/api/reqpurchase/optionChange/apply', Object.assign(this.body(), { token: this.result.confirm.token, exp: this.result.confirm.exp, planHash: this.result.planHash }))
        if (r.data.요청결과 !== '성공') throw new Error(r.data.error && r.data.error.errorMessage || '应用失败 (적용 실패)')
        this.done = r.data; this.result = null
        this.$emit('applied')
        this.loadLogs()
      } catch (e) { console.error('optionChange apply', e); this.error = e.message } finally { this.applying = false }
    },
    async loadLogs() {
      try {
        const r = await axios.post('/api/reqpurchase/optionChange/log', { orderNo: this.orderNo })
        this.logs = r.data.요청결과 === '성공' ? r.data.logs : []
      } catch (e) { console.error('optionChange log', e); this.logs = [] }
    },
    async revert(l) {
      if (!window.confirm('恢复到更换前？\n되돌리시겠습니까?')) return
      this.error = ''
      try {
        const r = await axios.post('/api/reqpurchase/optionChange/revert', { changeId: l.changeId, confirm: true })
        if (r.data.요청결과 !== '성공') throw new Error(r.data.error && r.data.error.errorMessage || '恢复失败 (되돌리기 실패)')
        this.$emit('applied'); this.loadLogs()
      } catch (e) { console.error('optionChange revert', e); this.error = e.message }
    }
  }
}
</script>
